// Fit ramp helper — maps a BidWin Score to a fit level and its token classes.
// Fit (how good a match) is a DIFFERENT dimension from urgency (how soon it
// closes); they never share a color. Thresholds mirror
// ContractMatcher.THRESHOLDS (strong ≥ 70, moderate 50–69, weak < 50).

export type FitLevel = 'strong' | 'moderate' | 'weak';

export function fitLevel(score: number): FitLevel {
  if (score >= 70) return 'strong';
  if (score >= 50) return 'moderate';
  return 'weak';
}

export const FIT_LABEL: Record<FitLevel, string> = {
  strong: 'Strong',
  moderate: 'Moderate',
  weak: 'Weak',
};

// One-line verdict per level (engine-agnostic default; callers may override).
export const FIT_VERDICT: Record<FitLevel, string> = {
  strong: 'Strong fit — recommend pursuing',
  moderate: 'Moderate fit — review required',
  weak: 'Weak fit — low priority',
};

// Tailwind class fragments (token-driven, theme-aware via CSS vars).
export const FIT_TEXT: Record<FitLevel, string> = {
  strong: 'text-fit-strong',
  moderate: 'text-fit-moderate',
  weak: 'text-fit-weak',
};

export const FIT_PILL: Record<FitLevel, string> = {
  strong: 'bg-fit-strong-bg text-fit-strong border border-fit-strong-border',
  moderate: 'bg-fit-moderate-bg text-fit-moderate border border-fit-moderate-border',
  weak: 'bg-fit-weak-bg text-fit-weak border border-fit-weak-border',
};

// Actual CSS colors for SVG stroke / progress-bar fill (follow the theme).
export const FIT_STROKE: Record<FitLevel, string> = {
  strong: 'rgb(var(--bw-fit-strong-stroke))',
  moderate: 'rgb(var(--bw-fit-moderate-stroke))',
  weak: 'rgb(var(--bw-fit-weak-stroke))',
};

export const TRACK_COLOR = 'rgb(var(--bw-track))';

// Progress-bar fill class by raw percentage (strong/moderate/weak bands).
export function barFillClass(pct: number): string {
  if (pct >= 70) return 'bg-fit-strong-stroke';
  if (pct >= 40) return 'bg-fit-moderate-stroke';
  return 'bg-fit-weak-stroke';
}

export function barTextClass(pct: number): string {
  if (pct >= 70) return 'text-fit-strong';
  if (pct >= 40) return 'text-fit-moderate';
  return 'text-fit-weak';
}
